export const OneTimeFrequency = ['One Time'];
export const RecurringFrequency = ['monthly', 'per 10000 operations', 'per rule', 'yearly'];
